import $ from 'jquery'
import M from 'materialize-css'
import { showNoticeCookiesPage } from './cookies'
import '../../../../../../node_modules/materialize-css/dist/js/materialize.min'

import {QA} from './util'



window.addEventListener('load', function () {
    M.Collapsible.init(document.querySelector('.collapsible'), {
        accordion: true
    });

    M.Tabs.init(QA('.tabs'), {
        onShow: function () {
            //dm.AjaxEvent("pageview")
            //console.log('ajax pageview tab open')
        }
    })

    if (window.location.pathname === '/piskotki' || window.location.pathname === '/piskotki/') {
        M.Modal.init(QA('.modal'), {
            onOpenStart: function () {
                //dm.AjaxEvent("pageview")
                //console.log('ajax pageview modal open')
            },
            onCloseEnd: function () {
                $('.notice').css('display', 'block');
                showNoticeCookiesPage();
            },
            startingTop: '5%',
            endingTop: '5%'
        })
    } else {
        M.Modal.init(QA('.modal'), {
            onOpenStart: function () {
                //dm.AjaxEvent("pageview")
                //console.log('ajax pageview modal open')
            },
            onCloseEnd: function () {
            }
        })
    }

})

